/**
 * Defensive localStorage access.
 *
 * WKWebView's localStorage can THROW on read/write (storage disabled, quota,
 * or a corrupted WebKit store) — and several of this app's boot-time reads run
 * at module-init, BEFORE first paint, where an uncaught throw takes down the
 * whole bundle. These wrappers fail soft (return the fallback) and report the
 * failure to Firebase so we can confirm/deny the "corrupt storage" hypothesis.
 */
export function safeGetItem(key, fallback = null) {
  try {
    const v = localStorage.getItem(key)
    return v === null || v === undefined ? fallback : v
  } catch (e) {
    try {
      window.__diag?.event?.('diag_storage_error', { op: 'get', key: String(key) })
    } catch (_) {}
    return fallback
  }
}

export function safeSetItem(key, value) {
  try {
    localStorage.setItem(key, value)
    return true
  } catch (e) {
    try {
      window.__diag?.event?.('diag_storage_error', { op: 'set', key: String(key) })
    } catch (_) {}
    return false
  }
}
